import { useState, useEffect, useRef } from "react";
import { List, X } from "@phosphor-icons/react";
import Logo from "@/components/Logo";

const navLinks = [
  { label: "What We Do", href: "#what-we-do" },
  { label: "The Product", href: "#product" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "Pricing", href: "#pricing" },
  { label: "FAQ", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [demoOpen, setDemoOpen] = useState(false);
  const demoRef = useRef(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (demoRef.current && !demoRef.current.contains(e.target)) setDemoOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const scrollTo = (href) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      data-testid="navbar"
      className={`fixed w-full top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-white/90 border-b border-[#1D3557]/5 shadow-sm"
          : "bg-white/70 backdrop-blur-sm"
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 py-3 flex items-center justify-between">
        <a href="#" className="flex items-center gap-2" data-testid="logo-link">
          <Logo size={28} />
          <span className="font-heading font-black text-xl uppercase tracking-tight text-[#1D3557]">
            target<span className="text-[#E63946]">funder</span><span className="text-[#1D3557]/30">.com</span>
          </span>
        </a>

        <div className="hidden lg:flex items-center gap-7">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => scrollTo(link.href)}
              className="font-body text-xs font-semibold text-[#1D3557]/50 hover:text-[#1D3557] transition-colors uppercase tracking-widest"
              data-testid={`nav-${link.label.toLowerCase().replace(/\s/g, "-")}`}
            >
              {link.label}
            </button>
          ))}

          {/* Demo button - direct link */}
          <div className="relative" ref={demoRef}>
            <a
              href="https://app.targetfunder.com/demo/create?sport=golf"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#E63946] text-white font-bold uppercase tracking-widest px-5 py-2.5 text-xs hover:bg-[#d32f3c] transition-colors"
              data-testid="nav-demo-btn"
            >
              Free Demo
            </a>
          </div>
        </div>

        <button
          className="lg:hidden text-[#1D3557]"
          onClick={() => setMobileOpen(!mobileOpen)}
          data-testid="mobile-menu-btn"
        >
          {mobileOpen ? <X size={24} /> : <List size={24} />}
        </button>
      </div>

      {mobileOpen && (
        <div className="lg:hidden bg-white border-t border-[#1D3557]/5 px-6 py-6 flex flex-col gap-4" data-testid="mobile-menu">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => scrollTo(link.href)}
              className="text-left font-body text-sm text-[#1D3557]/60 hover:text-[#1D3557] transition-colors"
            >
              {link.label}
            </button>
          ))}
          <a
            href="https://app.targetfunder.com/demo/create?sport=golf"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#E63946] text-white font-bold uppercase tracking-widest px-5 py-2.5 text-xs hover:bg-[#d32f3c] transition-colors mt-2 text-center"
          >
            Free Demo
          </a>
        </div>
      )}
    </nav>
  );
}
